module.exports = __webpack_public_path__ + "static/img/4.cc1793b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/4.png
// module id = KYlz
// module chunks = 0